import type { IDeveloperField } from 'dromo-uploader-js';

export const LEASE_FIELDS: IDeveloperField[] = [
  {
    key: 'property',
    type: 'string',
    label: 'Property',
    validators: []
  },
  {
    key: 'propertyId',
    type: [
      'number',
      'integer'
    ],
    label: 'Property ID',
    validators: []
  },
  {
    key: 'suite',
    type: 'string',
    label: 'Suite',
    validators: [
      {
        validate: 'required'
      }
    ]
  },
  {
    key: 'leaseExpirationDate',
    type: [
      'date',
      {
        displayFormat: 'MM/dd/yyyy'
      }
    ],
    label: 'Lease Expiration Date',
    validators: [
      {
        validate: 'required'
      }
    ]
  },
  {
    key: 'available',
    type: 'select',
    label: 'Available',
    validators: [
      {
        validate: 'required'
      }
    ],
    selectOptions: [
      {
        label: 'Yes',
        value: 'yes'
      },
      {
        label: 'No',
        value: 'no'
      }
    ]
  },
  {
    key: 'tenantName',
    type: 'string',
    label: 'Tenant',
    validators: []
  },
  {
    key: 'tenantContactId',
    type: [
      'number',
      'integer'
    ],
    label: 'Tenant Contact ID',
    validators: []
  },
  {
    key: 'tenantRole',
    type: 'select',
    label: 'Tenant Role',
    validators: [],
    selectOptions: [
      {
        label: 'Tenant',
        value: 'tenant'
      },
      {
        label: 'Tenant Contact',
        value: 'tenant_contact'
      }
    ]
  },
  {
    key: 'ownerName',
    type: 'string',
    label: 'Owner/Landlord',
    validators: []
  },
  {
    key: 'ownerContactId',
    type: [
      'number',
      'integer'
    ],
    label: 'Owner/Landlord Contact ID',
    validators: []
  },
  {
    key: 'ownerRole',
    type: 'select',
    label: 'Owner/Landlord Role',
    validators: [],
    selectOptions: [
      {
        label: 'Owner / Landlord',
        value: 'owner_landlord'
      },
      {
        label: 'Owner / User',
        value: 'owner_user'
      },
      {
        label: 'Owner Contact',
        value: 'owner_representative'
      }
    ]
  },
  {
    key: 'spaceTypeId',
    type: 'select',
    label: 'Space Type',
    validators: [],
    selectOptions: [
      {
        label: 'Office-Office Building',
        value: '101'
      },
      {
        label: 'Office-Creative/Loft',
        value: '102'
      },
      {
        label: 'Office-Executive Suites',
        value: '103'
      },
      {
        label: 'Office-Medical',
        value: '104'
      },
      {
        label: 'Office-Institutional/Governmental',
        value: '105'
      },
      {
        label: 'Office-Office Warehouse',
        value: '106'
      },
      {
        label: 'Office-Office Condo',
        value: '107'
      },
      {
        label: 'Retail-Street Retail',
        value: '201'
      },
      {
        label: 'Retail-Strip Center',
        value: '202'
      },
      {
        label: 'Retail-Free Standing Building',
        value: '203'
      },
      {
        label: 'Retail-Regional Mall',
        value: '204'
      },
      {
        label: 'Retail-Retail Pad',
        value: '205'
      },
      {
        label: 'Retail-Vehicle Related',
        value: '206'
      },
      {
        label: 'Retail-Outlet Center',
        value: '207'
      },
      {
        label: 'Retail-Power Center',
        value: '208'
      },
      {
        label: 'Retail-Neighborhood Center',
        value: '209'
      },
      {
        label: 'Retail-Community Center',
        value: '210'
      },
      {
        label: 'Retail-Specialty Center',
        value: '211'
      },
      {
        label: 'Retail-Theme/Festival Center',
        value: '212'
      },
      {
        label: 'Retail-Restaurant',
        value: '213'
      },
      {
        label: 'Retail-Post Office',
        value: '214'
      },
      {
        label: 'Retail-Retail Condo',
        value: '215'
      },
      {
        label: 'Industrial-Manufacturing',
        value: '301'
      },
      {
        label: 'Industrial-Warehouse/Distribution',
        value: '302'
      },
      {
        label: 'Industrial-Flex Space',
        value: '303'
      },
      {
        label: 'Industrial-Research & Development',
        value: '304'
      },
      {
        label: 'Industrial-Refrigerated/Cold Storage',
        value: '305'
      },
      {
        label: 'Industrial-Office Showroom',
        value: '306'
      },
      {
        label: 'Industrial-Truck Terminal/Hub/Transit',
        value: '307'
      },
      {
        label: 'Industrial-Self Storage',
        value: '308'
      },
      {
        label: 'Industrial-Industrial Condo',
        value: '309'
      },
      {
        label: 'Land-Office',
        value: '501'
      },
      {
        label: 'Land-Retail',
        value: '502'
      },
      {
        label: 'Land-Retail-Pad',
        value: '503'
      },
      {
        label: 'Land-Industrial',
        value: '504'
      },
      {
        label: 'Land-Residential',
        value: '505'
      },
      {
        label: 'Land-Multifamily',
        value: '506'
      },
      {
        label: 'Land-Other',
        value: '507'
      },
      {
        label: 'Multifamily-High-Rise',
        value: '601'
      },
      {
        label: 'Multifamily-Mid-Rise',
        value: '602'
      },
      {
        label: 'Multifamily-Low-Rise/Garden',
        value: '603'
      },
      {
        label: 'Multifamily-Government Subsidized',
        value: '604'
      },
      {
        label: 'Multifamily-Mobile Home Park',
        value: '605'
      },
      {
        label: 'Multifamily-Senior Living',
        value: '606'
      },
      {
        label: 'Multifamily-Skilled Nursing',
        value: '607'
      },
      {
        label: 'Special Purpose-School',
        value: '701'
      },
      {
        label: 'Special Purpose-Marina',
        value: '702'
      },
      {
        label: 'Special Purpose-Other',
        value: '703'
      },
      {
        label: 'Special Purpose-Golf Course',
        value: '704'
      },
      {
        label: 'Special Purpose-Church',
        value: '705'
      },
      {
        label: 'Hospitality-Full Service',
        value: '801'
      },
      {
        label: 'Hospitality-Limited Service',
        value: '802'
      },
      {
        label: 'Hospitality-Select Service',
        value: '803'
      },
      {
        label: 'Hospitality-Resort',
        value: '804'
      },
      {
        label: 'Hospitality-Economy',
        value: '805'
      },
      {
        label: 'Hospitality-Extended Stay',
        value: '806'
      },
      {
        label: 'Hospitality-Casino',
        value: '807'
      }
    ]
  },
  {
    key: 'leaseRate',
    type: [
      'number',
      'usd'
    ],
    label: 'Lease Rate',
    validators: []
  },
  {
    key: 'leaseRateMeasurement',
    type: 'select',
    label: 'Lease Rate Measurement',
    validators: [],
    selectOptions: [
      {
        label: '$ / SF / year',
        value: 'sf_per_year'
      },
      {
        label: '$ / SF / month',
        value: 'sf_per_month'
      },
      {
        label: '$ / Acres / year',
        value: 'acre_per_year'
      },
      {
        label: '$ / Acres / month',
        value: 'acre_per_month'
      },
      {
        label: '$ / year',
        value: 'per_year'
      },
      {
        label: '$ / month',
        value: 'per_month'
      }
    ]
  },
  {
    key: 'leaseTermMonths',
    type: [
      'number',
      'default'
    ],
    label: 'Lease Term (mo.)',
    validators: []
  },
  {
    key: 'leaseType',
    type: 'select',
    label: 'Lease Type',
    validators: [],
    selectOptions: [
      {
        label: 'Gross',
        value: '1'
      },
      {
        label: 'Modified Gross',
        value: '2'
      },
      {
        label: 'NNN',
        value: '3'
      },
      {
        label: 'Modified Net',
        value: '4'
      },
      {
        label: 'Full Service',
        value: '5'
      },
      {
        label: 'Ground Lease',
        value: '6'
      }
    ]
  },
  {
    key: 'leaseStatus',
    type: 'select',
    label: 'Lease Status',
    validators: [],
    selectOptions: [
      {
        label: 'New Lease',
        value: 'new_lease'
      },
      {
        label: 'Renewal',
        value: 'renewal'
      },
      {
        label: 'Expansion',
        value: 'expansion'
      }
    ]
  },
  {
    key: 'sublease',
    type: 'checkbox',
    label: 'Sublease',
    validators: []
  },
  {
    key: 'escalationPercent',
    type: [
      'number',
      'percent'
    ],
    label: 'Escalation %',
    validators: []
  },
  {
    key: 'ner',
    type: [
      'number',
      'usd'
    ],
    label: 'NER($)',
    validators: []
  },
  {
    key: 'leaseNote',
    type: 'string',
    label: 'Lease Note',
    validators: []
  },
  {
    key: 'sideRepresented',
    type: 'select',
    label: 'Side Represented',
    validators: [],
    selectOptions: [
      {
        label: 'Buyer Tenant',
        value: 'buyer_tenant'
      },
      {
        label: 'Seller Landlord',
        value: 'seller_landlord'
      },
      {
        label: 'Split',
        value: 'split_rep'
      },
      {
        label: 'Dual',
        value: 'dual'
      }
    ]
  },
  {
    key: 'sizeSf',
    type: [
      'number',
      'default'
    ],
    label: 'Size (SF)',
    validators: []
  },
  {
    key: 'minDivisibleSf',
    type: [
      'number',
      'default'
    ],
    label: 'Min Divisible (SF)',
    validators: []
  },
  {
    key: 'maxContiguousSf',
    type: [
      'number',
      'default'
    ],
    label: 'Max Contiguous (SF)',
    validators: []
  },
  {
    key: 'cam',
    type: [
      'number',
      'usd'
    ],
    label: 'CAM',
    validators: []
  },
  {
    key: 'camDescription',
    type: 'string',
    label: 'CAM Description',
    validators: []
  },
  {
    key: 'additionalRent',
    type: [
      'number',
      'usd'
    ],
    label: 'Additional Rent',
    validators: []
  },
  {
    key: 'description',
    type: 'string',
    label: 'Description',
    validators: []
  },
  {
    key: 'businessPark',
    type: 'string',
    label: 'Business Park',
    validators: []
  }
];

export const SALE_FIELDS: IDeveloperField[] = [
  {
    key: 'property',
    type: 'string',
    label: 'Property',
    validators: []
  },
  {
    key: 'propertyId',
    type: [
      'number',
      'integer'
    ],
    label: 'Property ID',
    validators: []
  },
  {
    key: 'salePrice',
    type: [
      'number',
      'usd'
    ],
    label: 'Sale Price',
    validators: [
      {
        validate: 'required'
      }
    ]
  },
  {
    key: 'saleDate',
    type: [
      'date',
      {
        displayFormat: 'MM/dd/yyyy'
      }
    ],
    label: 'Sale Date',
    validators: [
      {
        validate: 'required'
      }
    ]
  },
  {
    key: 'buyerName',
    type: 'string',
    label: 'Buyer Name',
    validators: []
  },
  {
    key: 'buyerContactId',
    type: [
      'number',
      'integer'
    ],
    label: 'Buyer Contact ID',
    validators: []
  },
  {
    key: 'buyerRole',
    type: 'select',
    label: 'Buyer Role',
    validators: [],
    selectOptions: [
      {
        label: 'Buyer',
        value: 'buyer'
      },
      {
        label: 'Buyer Contact',
        value: 'buyer_contact'
      }
    ]
  },
  {
    key: 'sellerName',
    type: 'string',
    label: 'Seller Name',
    validators: []
  },
  {
    key: 'sellerContactId',
    type: [
      'number',
      'integer'
    ],
    label: 'Seller Contact ID',
    validators: []
  },
  {
    key: 'sellerRole',
    type: 'select',
    label: 'Seller Role',
    validators: [],
    selectOptions: [
      {
        label: 'Seller',
        value: 'seller'
      },
      {
        label: 'Seller Contact',
        value: 'seller_contact'
      }
    ]
  },
  {
    key: 'listedDate',
    type: [
      'date',
      {
        displayFormat: 'MM/dd/yyyy'
      }
    ],
    label: 'Listed Date',
    validators: []
  },
  {
    key: 'description',
    type: 'string',
    label: 'Description',
    validators: []
  },
  {
    key: 'businessPark',
    type: 'string',
    label: 'Business Park',
    validators: []
  },
  {
    key: 'source',
    type: 'string',
    label: 'Source',
    validators: []
  },
  {
    key: 'availability',
    type: 'select',
    label: 'Availability',
    validators: [],
    selectOptions: [
      {
        label: 'On Market',
        value: 'on_market'
      },
      {
        label: 'Historical Sale',
        value: 'historical_sale'
      }
    ]
  },
  {
    key: 'saleNote',
    type: 'string',
    label: 'Sale Note',
    validators: []
  },
  {
    key: 'sideRepresented',
    type: 'select',
    label: 'Side Represented',
    validators: [],
    selectOptions: [
      {
        label: 'Buyer Tenant',
        value: 'buyer_tenant'
      },
      {
        label: 'Seller Landlord',
        value: 'seller_landlord'
      },
      {
        label: 'Split',
        value: 'split_rep'
      },
      {
        label: 'Dual',
        value: 'dual'
      }
    ]
  },
  {
    key: 'totalConsiderations',
    type: [
      'number',
      'default'
    ],
    label: 'Total Considerations',
    validators: []
  },
  {
    key: 'capRatePercent',
    type: [
      'number',
      'percent'
    ],
    label: 'Cap Rate %',
    validators: []
  },
  {
    key: 'netOperatingIncome',
    type: [
      'number',
      'usd'
    ],
    label: 'Net Operating Income',
    validators: []
  },
  {
    key: 'listingPrice',
    type: [
      'number',
      'usd'
    ],
    label: 'Listing Price',
    validators: []
  },
  {
    key: 'loanAmount',
    type: [
      'number',
      'usd'
    ],
    label: 'Loan Amount',
    validators: []
  }
];
